
export const LEFT_MENU_INDEX = {
    CODE: 0,
    NAME: 1,
}

export const LEFT_MENU_PREF_SHINNKO_CITY_INDEX = {
    PREF_CODE: 0,
    PREF_NAME: 1,
    SHINKO_CODE: 2,
    SHINKO_NAME: 3,
    CITY_CODE: 4,
    CITY_NAME: 5,
}

export const RISK_INDEX = {
    CODE: 0,
    RISK_VAL: 1,
    H1_VAL: 2,
    SOIL_VAL: 3,
    CITY_CODE: 4,
}

export const FLOOD_RISK_INDEX = {
    CODE: 0,
    RISK_VAL: 1,
    H1_VAL: 2,
    BSN_CODE: 3,
    CITY_CODE: 4,
    AREA_CODE: 5,
    BSN_NAME: 6
}

export const CHRONOLOGY_INDEX = {
    RECEIPT_DATE: 0,
    CAT_CODE: 1,
    CAT_NAME: 2,
    CITY_CODE: 3,
    CITY_NAME: 4,
    MSH_CODE: 5,
    COLLAPSE: 6,
    WATERLV: 7,
    CAVE_IN: 8,
    ROAD: 9,
    FLOOD: 10,
    WATER_CHANNEL: 11,
    POWER_OUTAGE: 12,
    WATER_OUTAGE: 13,
    GAS: 14,
    COMMUNICATION: 15,
    WIND_LIGNTNING: 16,
    FIRE: 17,
    TSUNAMI: 18,
}